export const NAMES = [
  'metadata.settings.attributes.water_resistance',
  'metadata.settings.attributes.cladding_type',
  'metadata.settings.attributes.features',
  'metadata.settings.attributes.walking_surface',
  'metadata.settings.attributes.warranty',
];

export const NESTED_OPTIONS = {
  'metadata.settings.attributes.product_type': ['ice-water-barrier', 'underlayment'],
};
